import {
  Button,
  Stack,
  TextField,
  Typography,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { FormProvider } from 'react-hook-form';
import Radio from 'common/Radio';
import { ApiEndpoint } from '@constants/index';

import { TitlesWrapper, VisibleWrapper, StyledFormHelperText } from './styled';
import { useMarkLogic } from './useMarkLogic';

const MarkMutation = () => {
  const {
    gotMarketList,
    selectedMarket,
    paramId,
    isLoading,
    methods,
    errors,
    isSuccess,
    iceCream,
    pastry,
    pudding,
    isButtonLoading,
    largeImageMessage,
    productKindErrorMessage,
    setValue,
    onSubmit,
    register,
    handleSubmit,
  } = useMarkLogic();

  if (isLoading) {
    return <div>Loading</div>
  }

  return (
    <FormProvider {...methods}>
      <Stack
        onSubmit={handleSubmit(onSubmit)}
        component="form"
      >
        <Typography
          variant="h5"
          sx={{ mb: 4 }}
        >
          { paramId ? 'Edit Mark' : 'Create New Map Mark'}
        </Typography>

        <TitlesWrapper>
          <TextField
            {...register('latitude')}
            label="Latitude"
            error={!!errors.latitude}
            helperText={errors.latitude ? 'Latitude is required' : ''}
          />

          <TextField
            {...register('longitude')}
            label="Longitude"
            error={!!errors.longitude}
            helperText={errors.longitude ? 'Longitude is required' : ''}
          />

          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Markets</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedMarket}
              label="Market"
              error={!!errors?.marketId}
              onChange={(event) => {
                const { target: { value } } = event;

                setValue('marketId', value)
              }}
            >
              {gotMarketList.map((option) => (
                <MenuItem
                  key={option.id}
                  value={option.id}
                  sx={{ display: 'flex', gap: 1, alignItems: 'center' }}
                >
                  {option.images?.[0]?.url && (
                    <img
                      width="32"
                      height="32"
                      style={{ objectFit: 'contain' }}
                      src={`${ApiEndpoint}/${option.images[0].url}`}
                      alt={option.name}
                    />
                  )}
                  <span>
                    {option.name}
                    {' '}
                    {!option.visible ? ' (Hidden on site)' : ''}
                  </span>
                </MenuItem>
              ))}

            </Select>
          </FormControl>

          <div>
            <FormControlLabel
              control={(
                <Checkbox
                  value="remember"
                  color="primary"
                  checked={iceCream}
                  onChange={() => {
                    setValue('iceCream', !iceCream)
                  }}
                />
              )}
              label="Ice cream"
            />
            <FormControlLabel
              control={(
                <Checkbox
                  value="remember"
                  color="primary"
                  checked={pastry}
                  onChange={() => {
                    setValue('pastry', !pastry)
                  }}
                />
              )}
              label="Pastry"
            />
            <FormControlLabel
              control={(
                <Checkbox
                  value="remember"
                  color="primary"
                  checked={pudding}
                  onChange={() => {
                    setValue('pudding', !pudding)
                  }}
                />
              )}
              label="Pudding"
            />
            {productKindErrorMessage && <StyledFormHelperText>{productKindErrorMessage}</StyledFormHelperText>}
          </div>

        </TitlesWrapper>

        <VisibleWrapper>
          <Box>
            <Typography>
              Visibility in website
            </Typography>
            <Box>
              <Radio label="Yes" name="visible" canBe />
              <Radio label="No" name="visible" canBe={false} />
            </Box>
          </Box>
        </VisibleWrapper>
        {largeImageMessage && <StyledFormHelperText id="messages">{largeImageMessage}</StyledFormHelperText>}
        <p>{isSuccess}</p>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          sx={{ mt: 1 }}
          disabled={isButtonLoading}
        >
          {paramId ? 'UPDATE' : "CREATE"}
        </Button>
      </Stack>
    </FormProvider>
  );
};

export default MarkMutation;
